module.exports = __webpack_public_path__ + "static/1-07ffd5262c7cf01052954faac61aa390.jpg";